import React from 'react';
import { useTranslation } from 'react-i18next';

import { ButtonAdd } from '@modules/layout/atoms';
import { ListToolbar } from '@modules/layout/moleculas';
import { SchoolFormModal } from '@modules/schools/organisms';

type SchoolsListToolbarProps = {
    canGet: boolean;
};

const SchoolsListToolbar = (props: SchoolsListToolbarProps): React.ReactElement => {
    const { canGet } = props;

    const { t } = useTranslation(['schools']);

    const [openSchoolFormModal, setSchoolFormModal] = React.useState(false);

    const handleOpenSchoolFormModal = (): void => setSchoolFormModal(true);
    const handleCloseSchoolFormModal = (): void => setSchoolFormModal(false);

    return (
        <ListToolbar>
            <ButtonAdd onClick={handleOpenSchoolFormModal}>
                {t('schools:add_school.title')}
            </ButtonAdd>

            <SchoolFormModal
                canGet={canGet}
                open={openSchoolFormModal}
                onClose={handleCloseSchoolFormModal}
            />
        </ListToolbar>
    );
};

export { SchoolsListToolbar };
